export default __webpack_public_path__ + "static/media/fortuna-holding-banner.d0affc91.jpg";